<form [formGroup]="customerVehicleSearchForm">
  <div class="searchBox d-flex justify-content-center align-items-center">
    <div class="position-relative w-100">
      <input
      #searchBox
      type="text"
      placeholder="Enter vehicle rego"
      class="form-control"
      formControlName="customerVehicleSearch"
      autofocus
      (focus)="isFocus($event)"
      (blur)="lostFocus($event)"
      (keyup)="onKeyboard($event)"
      />
      <span
      class="position-absolute"
      style="right: 10px; top: 50%; transform: translateY(-50%);"
      *ngIf="loading$ | async"
      >
      <pos-app-spinner2 [dark]="true"></pos-app-spinner2>
      </span>
    </div>
    <div class="d-flex justify-content-center w-50">
      <button
        type="button"
        class="btn w-100 d-flex align-items-center justify-content-center"
        (click)="onSearch()"
        [disabled]="(loading$ | async) || customerVehicleSearchForm?.controls.customerVehicleSearch?.value?.length < 1"
      >
        <mat-icon fontIcon="search" aria-hidden="false" aria-label="Search Icon"></mat-icon>
        <span class="ml-2 text-uppercase">Search</span>
      </button>
    </div>
  </div>
  <div>
    <div #searchResult *ngIf="showTable && listOfCustomerWithSameRego.length > 0" class="searchResult">
      <div class="col-sm-12 text-center my-2 mb-2 arb-medium-heading">Vehicle Found with same Rego - Please select one</div>
      <div style="max-height: 300px; overflow-y: auto">
        <table *ngIf="listOfCustomerWithSameRego && listOfCustomerWithSameRego.length > 0" class="border table table-striped shadow-lg w-100">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase">
                <label>Customer Name</label>
              </th>
              <th scope="col" class="text-uppercase">
                <label>Customer Number</label>
              </th>
              <th scope="col" class="text-uppercase">
                <label>Vehicle Description</label>
              </th>
              <th scope="col" class="text-uppercase">
                <label>Vehicle Color</label>
              </th>
              <th scope="col" class="text-uppercase">
                <label>Promotions</label>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              (click)="selectCustomer(i)"
              *ngFor="let customerWithSameRego of listOfCustomerWithSameRego; let i = index"
              [ngClass]="i === indexFocus ? 'table-primary' : ''"
            >
              <td>
                <ngb-highlight
                  [result]="customerWithSameRego?.customerName"
                  [term]="customerVehicleSearchForm.get('customerVehicleSearch').value"
                ></ngb-highlight>
              </td>
              <td>
                <ngb-highlight
                  [result]="customerWithSameRego?.customerNumber"
                  [term]="customerVehicleSearchForm.get('customerVehicleSearch').value"
                ></ngb-highlight>
              </td>
              <td>
                <ngb-highlight
                  [result]="customerWithSameRego?.vehicleShortDescription"
                  [term]="customerVehicleSearchForm.get('customerVehicleSearch').value"
                ></ngb-highlight>
              </td>
              <td>
                <ngb-highlight
                  [result]="customerWithSameRego?.vehicleColour"
                  [term]="customerVehicleSearchForm.get('customerVehicleSearch').value"
                ></ngb-highlight>
              </td>

              <td>
                <!-- promotions is in array show promotion code seperate with commas-->
                <span *ngFor="let promo of customerWithSameRego?.promotions; let last = last">
                  <ngb-highlight
                    [result]="promo?.promotionCode + ' - ' + promo?.promotionShortDescription"
                    [term]="customerVehicleSearchForm.get('customerVehicleSearch').value"
                  ></ngb-highlight
                  ><span *ngIf="!last">, </span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="p-2 mt-1 text-danger searchResult" *ngIf="!!listOfCustomerWithSameRego && listOfCustomerWithSameRego.length === 0 && !!loading$">
        No result has found - Please try again
      </div>
      <div class="d-flex justify-content-end mt-2">
        <button type="button" class="btn btn-cancel text-uppercase" (click)="clearSearch()">Cancel</button>
      </div>
    </div>
  </div>
</form>
